import { normalizeText } from '@/utils/text';
import type { AskProposalQuestionRequest } from '@/types/backend-contracts';

export const browserQueryCacheVersion = 1;

export function buildCandidatesQueryKey(): readonly ['candidates', 'active'] {
  return ['candidates', 'active'];
}

export function buildTopicsQueryKey(): readonly ['topics', 'active'] {
  return ['topics', 'active'];
}

export function buildPublishedProposalsByCandidateQueryKey(candidateId: string): readonly ['candidateTopicProposals', 'byCandidate', string] {
  return ['candidateTopicProposals', 'byCandidate', candidateId];
}

export function buildCandidateTopicProposalQueryKey(candidateId: string, topicId: string): readonly ['candidateTopicProposals', string, string] {
  return ['candidateTopicProposals', candidateId, topicId];
}

export function buildAskProposalQuestionQueryKey(request: AskProposalQuestionRequest): readonly [
  'askProposalQuestion',
  number,
  string,
  string,
  string,
] {
  return [
    'askProposalQuestion',
    browserQueryCacheVersion,
    normalizeText(request.question),
    request.selectedCandidateId ?? '',
    normalizeText(request.selectedCandidateName ?? ''),
  ];
}

export function buildAnswerCacheByIdQueryKey(answerCacheId: string): readonly ['answerCacheById', number, string] {
  return ['answerCacheById', browserQueryCacheVersion, answerCacheId];
}

export function buildPoliticalMatchQuestionsQueryKey(): readonly ['politicalMatchQuestions', 'active'] {
  return ['politicalMatchQuestions', 'active'];
}

export function buildPoliticalMatchMatchesQueryKey(questionnaireVersion: string): readonly ['politicalMatchMatches', string] {
  return ['politicalMatchMatches', questionnaireVersion];
}
